const firebaseConfig = {
    apiKey: "AIzaSyBON0hAMiL1RHlQelXHvsFs_-aoFn1N8Tg",
    authDomain: "dragon-ryders.firebaseapp.com",
    projectId: "dragon-ryders",
    storageBucket: "dragon-ryders.appspot.com",
    messagingSenderId: "180886539413",
    appId: "1:180886539413:web:c5639c4f2e3a82f1b25f9c"
  };
  export default firebaseConfig;